// src/components/quality/TicketsCountForm.js
import { useState } from 'react';
import api from '../../services/api';

const TicketsCountForm = ({ projectId, onClose, onTicketsCountSaved }) => {
  const [formData, setFormData] = useState({
    count_date: '',
    count: ''
  });
  const [currentCount, setCurrentCount] = useState(null);
  const [loadingCount, setLoadingCount] = useState(false);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Очищаем ошибку при изменении полей
    if (error) setError(null);
    
    // Если изменили дату, сбрасываем количество
    if (name === 'count_date') {
      setFormData(prev => ({
        ...prev,
        count: ''
      }));
      setCurrentCount(null);
      
      // Если выбрана дата, загружаем текущее количество
      if (value) {
        loadCurrentCount(value);
      }
    }
  };
  
  // Загрузка текущего количества для выбранной даты
  const loadCurrentCount = async (date) => {
    setLoadingCount(true);
    try {
      const response = await api.get(`/tickets-count-by-day/check?project_id=${projectId}&count_date=${date}`);
      // Проверяем, есть ли запись в ответе (метод возвращает пустой объект, если записи нет)
      if (response.data && response.data.record) {
        setCurrentCount(response.data.record.count);
        setFormData(prev => ({
          ...prev,
          count: response.data.record.count.toString()
        }));
      } else {
        setCurrentCount(null);
        setFormData(prev => ({
          ...prev,
          count: ''
        }));
      }
    } catch (err) {
      console.error('Ошибка загрузки текущего количества:', err);
      setCurrentCount(null);
      setFormData(prev => ({
        ...prev,
        count: ''
      }));
    } finally {
      setLoadingCount(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);

    // Валидация
    if (!formData.count_date) {
      setError('Пожалуйста, выберите дату');
      setSubmitting(false);
      return;
    }

    if (!formData.count || isNaN(formData.count) || parseInt(formData.count) < 0) {
      setError('Пожалуйста, введите корректное количество (неотрицательное число)');
      setSubmitting(false);
      return;
    }

    try {
      // Используем общий метод upsert для создания или обновления
      await api.post('/tickets-count-by-day/upsert', {
        project_id: projectId,
        count_date: formData.count_date,
        count: parseInt(formData.count)
      });
      
      // Успешное сохранение
      if (onTicketsCountSaved) onTicketsCountSaved();
      if (onClose) onClose();
      
    } catch (err) {
      console.error('Ошибка сохранения количества обращений:', err);
      if (err.response && err.response.data) {
        setError(err.response.data.message || 'Не удалось сохранить количество обращений');
      } else {
        setError('Не удалось сохранить количество обращений. Проверьте подключение.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-content">
      <div className="modal-header">
        <h3>Количество обращений по дням</h3>
        <button type="button" className="text-modal-close" onClick={onClose} title="Закрыть">
          ×
        </button>
      </div>

      {error && <div className="form-error">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="count_date">Дата *</label>
          <input
            type="date"
            id="count_date"
            name="count_date"
            value={formData.count_date}
            onChange={handleChange}
            required
            style={{width: '100%'}}
          />
          <small>Поле обязательно для заполнения</small>
        </div>

        {formData.count_date && (
          <div className="form-group">
            <label htmlFor="count">Количество *</label>
            <input
              type="number"
              id="count"
              name="count"
              value={formData.count}
              onChange={handleChange}
              min="0"
              required
              style={{width: '100%'}}
              disabled={loadingCount}
            />
            {loadingCount ? (
              <small>Загрузка текущего значения...</small>
            ) : (
              <small>
                {currentCount !== null 
                  ? `Текущее значение: ${currentCount}`
                  : 'Введите количество обращений (неотрицательное число)'
                }
              </small>
            )}
          </div>
        )}

        <div className="modal-actions">
          {onClose && (
            <button
              type="button"
              className="btn-cancel"
              onClick={onClose}
              disabled={submitting}
            >
              Отмена
            </button>
          )}
          <button
            type="submit"
            className="btn-submit"
            disabled={submitting}
          >
            {submitting ? 'Сохранение...' : 'Сохранить'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TicketsCountForm;